import {ConfigService, ConnectPayload, ConnectErrorData} from "@shared-library";
import { inject } from "@angular/core";
import {Router} from "@angular/router";
import {FastenService} from "../services/fasten.service";
import {v4 as uuidv4} from 'uuid';
import {Subscription} from "rxjs";

//ConnectHelper will redirect to the dashboard or a support form on complete.
export function ConnectHelper(connectData: ConnectPayload): Subscription {
  const vaultApi = inject(FastenService) as FastenService;
  const configService = inject(ConfigService) as ConfigService;
  const router = inject(Router) as Router;

  if (!connectData.external_state) {
    connectData.external_state = uuidv4();
  }

  connectData.public_id = configService.systemConfig$.publicId;

  return vaultApi.accountConnectWithPopup(connectData).subscribe(
    (orgConnectionCallbackData) => {
      console.log(orgConnectionCallbackData)

      if(!orgConnectionCallbackData){
        return //wait for redirect
      }

      //Note: this code will only run when this.connectMode == popup
      //when connectMode == 'redirect', the user is redirected in the same window, and this code is never executed.

      configService.vaultProfileAddConnectedAccount(orgConnectionCallbackData)

      router.navigateByUrl('dashboard/accounts');
    },
    (err) => {
      console.error("Error parsing error data", err)

      try {
        let errData: ConnectErrorData;
        //check if type of error is a string or an object.
        //if it's a string, parse it as JSON
        if (typeof err === 'string') {
          errData = JSON.parse(err);
        } else if (typeof err.message === 'string') {
          errData = JSON.parse(err.message);
        } else {
          errData = err
        }

        if (errData.error == 'timeout') {
          return router.navigateByUrl('dashboard/accounts')
        } else {
          console.error('an error occurred while attempting to connect health system', err)
          router.navigate(['form/support'], {
            queryParams: {
              "error": errData.error || 'unknown_error_during_connect',
              "error_description": errData.error_description || 'an unknown error occurred during the connection process',

              "brand_id": connectData.brand_id,
              "portal_id": connectData.portal_id,
              "endpoint_id": connectData.endpoint_id,
              "org_connection_id": connectData.org_connection_id,
              "vault_profile_connection_id": connectData.vault_profile_connection_id,

              "external_id": connectData.external_id,
              "external_state": connectData.external_state || errData.external_state,
              "request_id": errData.request_id,
            }
          })
        }
      } catch (e){
        router.navigate(['form/support'], {
          queryParams: {
            "error": 'unknown_error_during_connect',
            "error_description": 'an unknown error occurred during the connection process',

            "brand_id": connectData.brand_id,
            "portal_id": connectData.portal_id,
            "endpoint_id": connectData.endpoint_id,
            "org_connection_id": connectData.org_connection_id,
            "vault_profile_connection_id": connectData.vault_profile_connection_id,

            "external_id": connectData.external_id,
            "external_state": connectData.external_state || err['external_state'],
          }
        })
      }

      return null
    })
}
